<script>
/**
 * THIS IS MEANT TO BE USED AS A MIXIN
 */

import { mapState } from "vuex";
import { SESSION_LENGTH_MS } from '../../constants_calendar';

const ONE_MIN = 60*1000;
const SESSION_END_PERIOD = 2*ONE_MIN; // is this nice

export default {
  name: "Timer",

  data() {
    return {
      timer: null,
      time_seconds: Date.now(),

      STATE: 0,
      states: {
        NULL: 0,              /* more than 10 min to start */
        LESS_THAN_TEN: 1,     /* 1-10 min to start */
        LESS_THAN_ONE: 2,     /* 0-1 min to start */
        STARTED: 3,           /* 0-2 min in session */
        GRACE_OVER: 4,        /* more than 2 min in session */
        SESSION_END: 5,       /* session is over */
      },
    };
  },
  computed: {
    ...mapState({
      userID: (state) => state.auth.user._id,
      prefers24Hours: (state) => state.cofocusPreferences.calendarPreferences.prefer24HourFormat,
    }),

    sessionHasStarted() {
      return this.nextSessionDateTimeMS && this.nextSessionDateTimeMS < this.time_seconds;
    },
    sessionHasFinished() {
      return this.nextSessionDateTimeMS && this.nextSessionDateTimeMS + SESSION_LENGTH_MS < this.time_seconds;
    },

    nextSession() {
      const nextSession = this.$store.getters["upcomingMatches/nextMatchData"];
      return nextSession ? nextSession : null;
    },
    nextSessionDateTimeMS() {
      if (this.nextSession) return this.nextSession.dateTimeMS;
      return null;
    },
    nextSessionEndTimeMS() {
      if (this.nextSessionDateTimeMS) return this.nextSessionDateTimeMS + SESSION_LENGTH_MS;
      return null; 
    },
    hasJoinedDuringSession() {
      if (this.nextSession) return this.nextSession.currentUserJoined;
      return false;
    },

    minutesToNextSession: {
      get() {
        return this.$store.state.upcomingMatches.minutesToNextSession;
      },
      set(newMinuteCount) {
        this.$store.dispatch("upcomingMatches/setMinutesToNextSession", newMinuteCount);
      }
    }

  },
  methods: {
    stopTimer() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
      /* console.log("@STOP_TIMER"); */
    },
    startTimer() {
      if (this.timer) clearInterval(this.timer);
      /* console.log("@START_TIMER"); */
      this.STATE = this.states.NULL;
      this.setTime();
      this.timer = setInterval(this.setTime, 1000);
    },

    setTime() {
      this.time_seconds = Date.now();
      if (!this.nextSessionDateTimeMS) return;
      const minutesToNextSession = Math.floor((this.nextSessionDateTimeMS - Date.now())/ONE_MIN);
      if (minutesToNextSession !== this.minutesToNextSession) {
        this.minutesToNextSession = minutesToNextSession;
      }
      this.setWindowTitle();
      this.performChecks();
    },

    performChecks() {
      switch(this.STATE) {
        case this.states.NULL:
          if (this.time_seconds < this.nextSessionDateTimeMS - 10*ONE_MIN) break;
          else {
            this.STATE = this.states.LESS_THAN_TEN;
          }
          // fallsthrough
        case this.states.LESS_THAN_TEN: 
          if (this.time_seconds < this.nextSessionDateTimeMS - ONE_MIN) {
            break;
          }
          else {
            this.STATE = this.states.LESS_THAN_ONE;
          }
          // fallsthrough
        case this.states.LESS_THAN_ONE: 
          if (this.time_seconds < this.nextSessionDateTimeMS) { 
            break;
          }
          else {
            this.STATE = this.states.STARTED;
          }
          // fallsthrough
        case this.states.STARTED:  
          if (this.time_seconds < this.nextSessionDateTimeMS + 2*ONE_MIN) {
            break;
          }
          else {
            this.STATE = this.states.GRACE_OVER;
          }
          // fallsthrough
        case this.states.GRACE_OVER: 
          if (this.time_seconds < this.nextSessionDateTimeMS + SESSION_LENGTH_MS) {
            break;
          }
          else {
            this.STATE = this.states.SESSION_END;
          }
          // fallsthrough
        case this.states.SESSION_END:  
          /* allow for SESSION_END_PERIOD to discuss stuff */ 
          if (this.time_seconds < this.nextSessionDateTimeMS + SESSION_LENGTH_MS + SESSION_END_PERIOD) {
            break;
          }
          this.STATE = this.states.NULL;
          break;
      }
    },

    setWindowTitle() {
      if (this.time_seconds < this.nextSessionDateTimeMS - 10*ONE_MIN) {
        window.document.title = "Cofocus - The land of co-productivity.";
      } else if (this.time_seconds < this.nextSessionDateTimeMS) {
        const timeString = (new Date(this.nextSessionDateTimeMS - this.time_seconds)).toISOString().substr(14, 5);
        window.document.title = `Session starts in ${timeString}`;
      } else if (this.time_seconds < this.nextSessionDateTimeMS + SESSION_LENGTH_MS) {
        const timeString = (new Date(this.nextSessionDateTimeMS + SESSION_LENGTH_MS - this.time_seconds)).toISOString().substr(14, 5);
        window.document.title = `${timeString} until end - Cofocus.one`;
      } else {
        window.document.title = "Cofocus - The land of co-productivity.";
      }
    },

    completeSession() {
      /* console.log("HAHAHAHAHAHAHAH fail"); */
      this.sessionCompletion = true;
    }
  },
  watch: {
    /* here because otherwise there was an infinite reevaluation loop */ 
    nextSessionDateTimeMS: function(newDate) {
      if (newDate) this.startTimer();
      else this.stopTimer();
    }
  },
  created() {
    /* console.log("@TIMER created:", this.nextSessionDateTimeMS); */
    if (this.nextSessionDateTimeMS) this.startTimer();
  },
  beforeDestroy() {
    this.stopTimer();
    window.document.title = "Cofocus - The land of co-productivity!";
  }
};
</script>